import { AnimatePresence } from 'framer-motion';
import React from 'react';

import { useModalStore } from 'state/modalStore';

import S from './ModalContainer.module.scss';

export interface ModalContainerProps {}

const ModalContainer: React.FC<ModalContainerProps> = ({ ...rest }) => {
  const node = useModalStore(store => store.modalComponent);

  return (
    <section
      className={S.ModalContainer}
      data-visible={(!!node).toString()}
      {...rest}
    >
      <div data-visible={(!!node).toString()} className={S.Blur} />

      <AnimatePresence mode="wait">{node}</AnimatePresence>
    </section>
  );
};

export default ModalContainer;
